module.exports = __webpack_public_path__ + "static/img/product-poster-8.ac5b39e2.png";